import uniqWith from "lodash.uniqwith";

import { EmployerNormalizedTag, ImportEmployerDocumentsOptions } from "./EmployeeServiceTypes";
import { EmployerDocumentsState } from "./EmployeeServiceState";

export const importDocumentOptionsHasRequestsTags = (options: ImportEmployerDocumentsOptions): boolean => {
    const hasRootRequestsTags =
        options.requestsTags != undefined &&
        options.requestsTags.length > 0 &&
        Array.isArray(options.requestsTags[0]) &&
        options.requestsTags[0].length > 0;

    if (!hasRootRequestsTags) {
        const filterSelectValues = Object.values(options.filter?.selectValues ?? {});

        if (filterSelectValues.length === 0) {
            return false;
        }

        const hasFilterRequestsTags = filterSelectValues.every(
            selectValues =>
                selectValues.length > 0 &&
                selectValues.every(
                    selectValue =>
                        selectValue.requestsTags?.length > 0 &&
                        Array.isArray(selectValue.requestsTags[0]) &&
                        selectValue.requestsTags[0].length > 0
                )
        );
        return hasFilterRequestsTags;
    }

    return hasRootRequestsTags;
};

export const getImportArguments = (
    options: ImportEmployerDocumentsOptions,
    tag: EmployerNormalizedTag,
    employerDocumentsState?: EmployerDocumentsState
): string[] => {
    let args = [options.gfv].concat(options.importArguments ?? []);
    args.push(tag.sourceTag);

    if (employerDocumentsState?.filterType && employerDocumentsState?.filterValue) {
        args.push(`xslt:${employerDocumentsState.filterType}:${employerDocumentsState.filterValue}`);
    }

    // region Deprecated
    if (options.instanceNumber != undefined) {
        args.push(`instanceNumber:${options.instanceNumber}`);
    }
    if (options.snils != undefined) {
        args.push(`snils:${options.snils}`);
    }
    // endregion

    args = uniqWith(args, (left, right) => left === right);

    return args;
};

export const formatFilterQuery = (query: string): string => query.replace(/'/g, `"`);
